export type VerifyExamResponse = {
    courseName: string
    courseDescription: string
    hasPassed: boolean
    examFinishedAt: Date
    participantFirstName: string
    participantLastName: string
    participantBirthdate: Date
    examValidityMonths: number
  }

export enum CertificateState {
  VALID = 'valid',
  EXPIRED = 'expired',
  INVALID = 'invalid',
}
  